import { useTranslation } from "react-i18next";
import { BsHouseFill, BsBuildingUp } from "react-icons/bs";

const ReportTypeSwitcher = ({ overviewImages, reportType, onSwitch }) => {
  const { t } = useTranslation();

  const roofOverview = overviewImages.find((img) => img.imageType === "roof");
  const facadeOverview = overviewImages.find((img) => img.imageType === "facade");

  const tabs = [
    {
      type: "roof",
      label: t("reportTypeSwitcher.roof", "Roof"),
      icon: <BsHouseFill className="text-base" />,
      overview: roofOverview,
    },
    {
      type: "facade",
      label: t("reportTypeSwitcher.facade", "Facade"),
      icon: <BsBuildingUp className="text-base" />,
      overview: facadeOverview,
    },
  ];

  return (
    <div className="ml-4 flex items-center gap-1 rounded-full bg-gray-100 p-1">
      {tabs.map((tab) => {
        const isActive = reportType === tab.type;
        const isDisabled =
          !tab.overview?.id ||
          tab.overview?.accessStatus === "not_access" ||
          tab.overview?.accessStatus === "revoke";
        return (
          <button
            key={tab.type}
            type="button"
            onClick={() => {
              if (!isDisabled && !isActive) {
                onSwitch(tab.type, tab.overview.id);
              }
            }}
            disabled={isDisabled}
            className={`flex items-center gap-2 rounded-full px-5 py-1.5 text-sm font-medium transition-all ${
              isDisabled
                ? "text-gray-300 cursor-not-allowed"
                : isActive
                  ? "bg-white text-[#3D6C50] shadow-sm"
                  : "text-gray-500 cursor-pointer hover:text-gray-700"
            }`}
          >
            {tab.icon}
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default ReportTypeSwitcher;
